<div class="container section__point-of-sale h-full">
  <div class="wrapper">
    <ng-container *ngIf="showContainerCode">
      <div class="sectionContainer fadeinright animation-duration-300">
        <article>
          <div class="mainInfo">
            <h1>{{ titleInit}}</h1>
            <p [innerHTML]="subTitleInit | safeHtml"></p>
          </div>

          <div class="backgroundArrow">
            <div class="arrowSvg">
              <svg width="55" height="39" viewBox="0 0 55 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5">
                  <path d="M29.4555 16.4348L18.4474 4.89504C16.9489 3.32418 14.4589 3.27616 12.8745 4.78756L1.23526 15.8906C-0.349133 17.402 -0.418519 19.8915 1.07997 21.4624L12.0881 33.0021C13.5866 34.573 16.0766 34.621 17.661 33.1096L29.3002 22.0066C30.8846 20.4952 30.954 18.0057 29.4555 16.4348ZM16.3354 31.72C15.5432 32.4757 14.2389 32.4505 13.4897 31.6651L2.48155 20.1253C1.73231 19.3399 1.76865 18.0359 2.56085 17.2802L14.2001 6.17717C14.9923 5.42146 16.2966 5.44662 17.0458 6.23205L28.054 17.7718C28.8032 18.5572 28.7669 19.8613 27.9747 20.617L16.3354 31.72Z" fill="#BCBCC2" />
                  <path d="M31.98 36.529L18.2631 22.1496C16.4188 20.2163 16.447 17.0736 18.458 15.1553L32.9004 1.37823C34.8504 -0.481957 37.9942 -0.480633 39.8962 1.51315L53.5555 15.8321C55.3998 17.7655 55.3715 20.9082 53.3605 22.8265L38.9182 36.6035C36.9648 38.5823 33.8243 38.4624 31.98 36.529Z" fill="#BCBCC2" />
                </g>
                <path class="svgStroke--secondary" d="M35 16L27.5 22.8182L20 16" stroke="#000" stroke-width="3"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="otpNumber" *ngIf="otpCode!== ''">
            <div class="otpNumber__content">
              <span>{{otpCode}}</span>
            </div>
          </div>

          <div class="loader__block" *ngIf="loading">
            <div class="loading-indicator">
              <p-progressSpinner></p-progressSpinner>
            </div>
            <p>{{ textLoading }}</p>
          </div>


          <!-- Revisar, no se le da uso -->
          <div class="error-message" *ngIf="messageError">
            <p [ngStyle]="{ color: '#D32F2F', fontWeight: 'bold', margin: '8px 0', fontSize: '1rem' }">
              {{ messageError }}
            </p>
          </div>

        </article>
      </div>
    </ng-container>

    <ng-container *ngIf="showContainerRetry">
      <div class="sectionContainer fadeinright animation-duration-300">
        <article>
          <div class="mainInfo">
            <h1>El código OTP no pudo ser generado</h1>
            <p>Por favor vuelve a intentarlo nuevamente cuando termine el tiempo.</p>
          </div>

          <div class="backgroundArrow">
            <div class="arrowSvg">
              <svg width="55" height="39" viewBox="0 0 55 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5">
                  <path d="M29.4555 16.4348L18.4474 4.89504C16.9489 3.32418 14.4589 3.27616 12.8745 4.78756L1.23526 15.8906C-0.349133 17.402 -0.418519 19.8915 1.07997 21.4624L12.0881 33.0021C13.5866 34.573 16.0766 34.621 17.661 33.1096L29.3002 22.0066C30.8846 20.4952 30.954 18.0057 29.4555 16.4348ZM16.3354 31.72C15.5432 32.4757 14.2389 32.4505 13.4897 31.6651L2.48155 20.1253C1.73231 19.3399 1.76865 18.0359 2.56085 17.2802L14.2001 6.17717C14.9923 5.42146 16.2966 5.44662 17.0458 6.23205L28.054 17.7718C28.8032 18.5572 28.7669 19.8613 27.9747 20.617L16.3354 31.72Z" fill="#BCBCC2" />
                  <path d="M31.98 36.529L18.2631 22.1496C16.4188 20.2163 16.447 17.0736 18.458 15.1553L32.9004 1.37823C34.8504 -0.481957 37.9942 -0.480633 39.8962 1.51315L53.5555 15.8321C55.3998 17.7655 55.3715 20.9082 53.3605 22.8265L38.9182 36.6035C36.9648 38.5823 33.8243 38.4624 31.98 36.529Z" fill="#BCBCC2" />
                </g>
                <path class="svgStroke--secondary" d="M35 16L27.5 22.8182L20 16" stroke="#000" stroke-width="3"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="time__text">
            <p *ngIf="!buttonEnabled">Reintentar en: <strong>{{ formattedTime }}</strong></p>
            <p *ngIf="buttonEnabled">Puedes volver a intentarlo haciendo click en el botón <strong>"Reintentar"</strong></p>
          </div>
        </article>
      </div>

      <footer>
        <div class="footer__content">
          <button pButton pRipple label="Reintentar" icon="pi pi-refresh" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onRetry()" [disabled]="!buttonEnabled"></button>
        </div>
      </footer>

    </ng-container>

    <ng-container *ngIf="showScreenCancel">
      <div class="sectionContainer fadeinright animation-duration-300">
        <article>
          <div class="mainInfo">
            <h1>El código OTP</h1>
            <p>{{ 'No se puede realizar el proceso para otorgar el crédito. Por favor,' | termReplace }} <br>presione  "Cancelar solicitud"</p>
          </div>

          <div class="backgroundArrow">
            <div class="arrowSvg">
              <svg width="55" height="39" viewBox="0 0 55 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5">
                  <path d="M29.4555 16.4348L18.4474 4.89504C16.9489 3.32418 14.4589 3.27616 12.8745 4.78756L1.23526 15.8906C-0.349133 17.402 -0.418519 19.8915 1.07997 21.4624L12.0881 33.0021C13.5866 34.573 16.0766 34.621 17.661 33.1096L29.3002 22.0066C30.8846 20.4952 30.954 18.0057 29.4555 16.4348ZM16.3354 31.72C15.5432 32.4757 14.2389 32.4505 13.4897 31.6651L2.48155 20.1253C1.73231 19.3399 1.76865 18.0359 2.56085 17.2802L14.2001 6.17717C14.9923 5.42146 16.2966 5.44662 17.0458 6.23205L28.054 17.7718C28.8032 18.5572 28.7669 19.8613 27.9747 20.617L16.3354 31.72Z" fill="#BCBCC2" />
                  <path d="M31.98 36.529L18.2631 22.1496C16.4188 20.2163 16.447 17.0736 18.458 15.1553L32.9004 1.37823C34.8504 -0.481957 37.9942 -0.480633 39.8962 1.51315L53.5555 15.8321C55.3998 17.7655 55.3715 20.9082 53.3605 22.8265L38.9182 36.6035C36.9648 38.5823 33.8243 38.4624 31.98 36.529Z" fill="#BCBCC2" />
                </g>
                <path class="svgStroke--secondary" d="M35 16L27.5 22.8182L20 16" stroke="#000" stroke-width="3"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div>
            <div class="backInnerButton" *ngIf="getCanCancelRequest()">
              <app-sales-cancel-request></app-sales-cancel-request>
            </div>
          </div>

        </article>
      </div>

    </ng-container>
  </div>
</div>

<p-dialog [(visible)]="visibleModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__icon">
          <span>
            <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M61.6795 9.4412L32.1677 38.9788L21.5219 28.3237C21.5219 28.3237 19.2311 26.5703 17.0749 28.7283C14.9188 30.8863 16.6707 33.1792 16.6707 33.1792L32.1677 48.6898L66.5307 14.2967C66.5307 14.2967 68.1478 12.0038 65.9917 9.9807C63.7008 7.95758 61.6795 9.4412 61.6795 9.4412Z" fill="#0046AD"/>
              <path d="M69.4955 32.2351C68.8217 31.5607 67.7437 31.1561 66.5308 31.1561C63.2967 31.1561 62.3534 33.5838 62.3534 34.9326C62.3534 42.0809 59.5235 48.8247 54.5375 53.815C49.5515 58.8054 42.6789 61.6378 35.6715 61.6378C28.5294 61.6378 21.7916 58.8054 16.8056 53.815C11.8196 48.8247 8.98968 41.946 8.98968 34.9326C8.98968 27.7842 11.8196 21.0405 16.8056 16.0501C21.7916 11.0597 28.6642 8.22736 35.6715 8.22736C38.0971 8.22736 40.6575 8.63199 43.0832 9.30636C45.6435 9.98073 47.5301 10.3854 49.1472 9.17148C50.2253 8.36223 50.8991 6.60886 50.7643 5.12524C50.6295 4.04624 50.0905 3.10212 49.1472 2.6975C47.3954 1.48362 40.2533 0 35.8063 0C31.0898 0 26.6428 0.944123 22.4654 2.6975C18.2879 4.45087 14.38 7.01349 11.1458 10.2505C4.13844 16.7245 0.5 25.6262 0.5 34.9326C0.5 44.3738 4.13843 53.1407 10.7415 59.7495C13.9757 62.9865 17.8836 65.5491 22.0611 67.3025C26.2386 69.0559 30.8203 70 35.402 70C44.835 70 53.5942 66.3584 60.1973 59.7495C66.8004 53.1407 70.4388 44.3738 70.4388 34.9326C70.5735 34.9326 70.5735 33.3141 69.4955 32.2351Z" fill="#0046AD"/>
            </svg>
          </span>
        </div>
        <div class="dialog__info">
          <h2>Confirmación recibida</h2>
          <p>{{ 'Recibimos de manera satisfactoria la confirmacion del otorgamiento del crédito. Ahora puedes continuar.' | termReplace }}</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onNextStep()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Modal de anulación exitosa -->
<p-dialog [(visible)]="showModalAnnulmentSuccess" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__icon">
          <span>
            <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M61.6795 9.4412L32.1677 38.9788L21.5219 28.3237C21.5219 28.3237 19.2311 26.5703 17.0749 28.7283C14.9188 30.8863 16.6707 33.1792 16.6707 33.1792L32.1677 48.6898L66.5307 14.2967C66.5307 14.2967 68.1478 12.0038 65.9917 9.9807C63.7008 7.95758 61.6795 9.4412 61.6795 9.4412Z" fill="#0046AD"/>
              <path d="M69.4955 32.2351C68.8217 31.5607 67.7437 31.1561 66.5308 31.1561C63.2967 31.1561 62.3534 33.5838 62.3534 34.9326C62.3534 42.0809 59.5235 48.8247 54.5375 53.815C49.5515 58.8054 42.6789 61.6378 35.6715 61.6378C28.5294 61.6378 21.7916 58.8054 16.8056 53.815C11.8196 48.8247 8.98968 41.946 8.98968 34.9326C8.98968 27.7842 11.8196 21.0405 16.8056 16.0501C21.7916 11.0597 28.6642 8.22736 35.6715 8.22736C38.0971 8.22736 40.6575 8.63199 43.0832 9.30636C45.6435 9.98073 47.5301 10.3854 49.1472 9.17148C50.2253 8.36223 50.8991 6.60886 50.7643 5.12524C50.6295 4.04624 50.0905 3.10212 49.1472 2.6975C47.3954 1.48362 40.2533 0 35.8063 0C31.0898 0 26.6428 0.944123 22.4654 2.6975C18.2879 4.45087 14.38 7.01349 11.1458 10.2505C4.13844 16.7245 0.5 25.6262 0.5 34.9326C0.5 44.3738 4.13843 53.1407 10.7415 59.7495C13.9757 62.9865 17.8836 65.5491 22.0611 67.3025C26.2386 69.0559 30.8203 70 35.402 70C44.835 70 53.5942 66.3584 60.1973 59.7495C66.8004 53.1407 70.4388 44.3738 70.4388 34.9326C70.5735 34.9326 70.5735 33.3141 69.4955 32.2351Z" fill="#0046AD"/>
            </svg>
          </span>
        </div>
        <div class="dialog__info">
          <h2>Anulación exitosa</h2>
          <p>La anulación ha sido realizada con éxito. Presiona el botón 'Continuar' para pedir un nuevo OTP.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="getOtp(); showModalAnnulmentSuccess = false;"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
